<div class="flex row margin-top-5">
  <div><i class="icon" [ngClass]="policyRiskIcons[0]"></i></div>
</div>
